export default __webpack_public_path__ + "static/form-one-column-dont-afffa901b05ebe824c307e1a69f51f0ede38e5030fc58a26cc6795755a31f235.png";